
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitchHorizontalOffLarge as ObiSwitchHorizontalOffLargeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-horizontal-off-large.js';
 
 
 

 
 export const ObiSwitchHorizontalOffLarge = createComponent({
   react: React,
   tagName: 'obi-switch-horizontal-off-large',
   elementClass: ObiSwitchHorizontalOffLargeElement,
   events: {
     
   }
  });
 
 